<!-- select式で、複数枚購入可能なチケット -->
<template>
  <div v-if="totalMaxPurchaseCount > 0" style="margin-bottom: 30px">
    <!-- dataDivisionsをループして表示 -->
    <div v-for="division in dataDivisions" :key="division.dataName">
      <div class="field">
        <!-- ラベル -->
        <label>{{ $t("common.passengers") }} ({{ division.name }})</label>
        <!-- ラベル -->

        <!-- セレクト欄 分子レベルへ切り分け可能 4/16-->
        <div class="select-wrap">
          <!-- セレクトボックス の上限値は、totalMaxPurchaseCount or division毎のmaxPurchaseCount のいずれか小さい方で可変的に設定する-->
          <select
            v-if="
              totalMaxPurchaseCount - totalSelectedCount + division.count <
              division.maxPurchaseCount
            "
            v-model="division.count"
          >
            <option :value="0">{{ 0 }}</option>
            <!-- 一回の決済で購入可能な最大値(totalMaxPurchaseCount) - 選択されている枚数の総量(totalSelectedCount) + このdivisionで選択されている数(division.count) = selectで選べる残枚数 -->
            <option
              v-for="n in totalMaxPurchaseCount -
              totalSelectedCount +
              division.count"
              :key="n"
              :value="n"
            >
              {{ n }}
            </option>
          </select>
          <select v-else v-model="division.count">
            <option :value="0">{{ 0 }}</option>
            <!-- divisionの最大枚数(gettable_count) -->
            <option v-for="n in division.maxPurchaseCount" :key="n" :value="n">
              {{ n }}
            </option>
          </select>
        </div>
        <!-- セレクト欄 分子レベルへ切り分け可能 4/16-->

        <!-- 赤エラー文言 -->
        <p
          v-if="division.maxPurchaseCount < division.count"
          class="error-block"
        >
          ※{{ division.name }}区分のチケットを{{
            division.maxPurchaseCount + 1
          }}枚以上所持することは<br />できません
        </p>
        <!-- 赤エラー文言 -->
      </div>
    </div>
    <!-- dataDivisionsをループして表示 -->

    <div class="error-block">
      ※合計最大{{ totalMaxPurchaseCount }}枚まで購入できます
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { onMounted, computed, watchEffect, ref } from "vue";

export default {
  name: "TheMbDivisionCountSelect",
  props: {
    dataDivisions: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    // チケット全体購入上限枚数(基本はmasterBook.max_purchase_countだが、limited_type: master_bookの場合は、gettable_counts[0]も見る必要がある)
    const totalMaxPurchaseCount = ref(0);

    const totalSelectedCount = computed(() => {
      var i = 0;
      props.dataDivisions.forEach((e) => {
        i = i + e.count;
      });
      return i;
    });

    onMounted(() => {
      const groupUseMaxPurchaseCount = 1;
      // 複数人利用チケットの場合、アプリでの購入上限枚数はgroupUseMaxPurchaseCountに固定する
      if (masterBook.value.content?.description_json?.GroupUse === true) {
        totalMaxPurchaseCount.value = groupUseMaxPurchaseCount;
        return;
      }

      if (
        masterBook.value._max_purchase_count[0].limited_type == "master_book" &&
        masterBook.value._max_purchase_count[0].gettable_counts[0].count <
          masterBook.value.max_purchase_count
      ) {
        totalMaxPurchaseCount.value =
          masterBook.value._max_purchase_count[0].gettable_counts[0].count;
      } else {
        totalMaxPurchaseCount.value = masterBook.value.max_purchase_count;
      }
    });

    return {
      totalSelectedCount,
      totalMaxPurchaseCount,
      masterBook,
    };
  },
};
</script>

<style lang="scss" scoped>
.field {
  position: relative;
  margin: 0 0 15px 0;
}

label {
  position: absolute;
  width: auto;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 0;
  background-color: #ffffff;
  outline: none;
  padding: 5px 10px 5px 220px;
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
  color: #000000;
}

select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 0;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 15px;
  margin-top: -6px;
}

.error-block {
  margin: 5px 0 0 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}
</style>
